"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.unwrap = ({ el, parentTimestamp, log, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const tagJsx = react_1.default.createElement("code", null,
        "<",
        el.tagName.toLowerCase(),
        " />");
    const { parentNode } = el;
    if (parentNode) {
        while (el.firstChild) {
            parentNode.insertBefore(el.firstChild, el);
        }
        parentNode.removeChild(el);
        log('success', {
            message: react_1.default.createElement(react_1.default.Fragment, null,
                "Unwrapped ",
                tagJsx,
                "."),
            parentTimestamp,
            previewHtml: el.outerHTML,
        });
    }
    else {
        log('error', {
            message: react_1.default.createElement(react_1.default.Fragment, null,
                "Could not unwrap ",
                tagJsx,
                " because there was no parent."),
            parentTimestamp,
        });
    }
    return el;
});
//# sourceMappingURL=unwrap.js.map